import gql from 'graphql-tag';
import { Fragments } from '../fragments';

export const createLink = gql`
  mutation CreateLinkMutation($url: String!, $name: String!, $businessId: Int!) {
    createChannel(
      input: { channel: { type: LINK, name: $name, urlLink: $url, businessId: $businessId } }
    ) {
      link: channel {
        ...ToolLinkListItem
      }
    }
  }

  ${Fragments.tool.link}
`;

export const deleteLink = gql`
  mutation DeleteLinkMutation($id: Int!) {
    deleteChannel(id: $id)
  }
`;
